import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useHistorySearch() {
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const search = params.get('search');

    const onSearch = React.useCallback(
        (phrase: string) => {
            if (phrase !== search) {
                navigate(
                    phrase.length
                        ? `${location.pathname}?search=${encodeURIComponent(phrase)}`
                        : location.pathname,
                    { replace: true }
                );
            }
        },
        [location.pathname, navigate, search]
    );

    return { search, onSearch };
}
